<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <h3>REPORTE CONSOLIDADO</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="form-control-label">Seleccione la Fecha</label>
                            <date-picker :default-value="fecha" v-model="fecha" :range="false" format="DD-MM-YYYY" :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                        </div>
                    </div>

                    <div class="col">
                        <!-- <select name="" id="" v-model="mps_id" class="form-control">
                            <option :value="m.id" v-for="m in materias_primas" :key="m.id">{{m.nombre}}</option>
                        </select> -->
                        
                        <!-- <div class="form-group">
                            <label for="form-control-label">Seleccione Materia Prima</label>
                            <v-select class="" :reduce="option => option.id" v-model="mps_id" :options="materias_primas" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div> -->
                    </div>
                    <div class="col">
                        <!-- <div class="form-group">
                            <label for="form-control-label">Seleccione Proveedores</label>
                            <v-select class="" :reduce="option => option.id" v-model="empresas_id" :closeOnSelect="false" :options="proveedores" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div> -->
                    </div>

                    <div class="col">
                        
                        <!-- <div class="form-group">
                            <label for="form-control-label">Seleccione Especie</label>
                            <v-select class="" :reduce="option => option.id" v-model="especies_id" :options="especies" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div> -->
                    </div>

                    <!-- <div class="col">
                        
                        <div class="form-group">
                            <label for="form-control-label">Seleccione Destino</label>
                            <v-select class="" :reduce="option => option.id" v-model="destinos_id" :options="destinos" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div>
                    </div> -->

                    <div class="col">
                        <button class="btn btn-primary btn-icon" @click="cargar_datos">Cargar</button>
                        <button v-show="url_excel" class="btn btn-success btn-icon" @click="exportar_excel">Excel</button>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <label class="margen-1" for="" ><input type="checkbox" id="" value="" v-model="agrupar_empresa"> Agrupar Empresa</label>
                    </div>
                </div>


                <!-- TABLAS DE REPORTES -->


            <div class="nav-wrapper">
                <ul class="nav nav-pills nav-fill flex-column flex-md-row" id="tabs-icons-text" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link mb-sm-3 mb-md-1 active" id="tabs-icons-text-1-tab" data-toggle="tab" href="#tabs-icons-text-1" role="tab" aria-controls="tabs-icons-text-1" aria-selected="true"><i class="fas fa-file mr-2"></i>Proy. vs Recep.</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link mb-sm-3 mb-md-1" id="tabs-icons-text-2-tab" data-toggle="tab" href="#tabs-icons-text-2" role="tab" aria-controls="tabs-icons-text-2" aria-selected="false"><i class="fas fa-file mr-2"></i>Proy vs Tipo MP</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link mb-sm-3 mb-md-1" id="tabs-icons-text-3-tab" data-toggle="tab" href="#tabs-icons-text-3" role="tab" aria-controls="tabs-icons-text-3" aria-selected="false"><i class="fas fa-file mr-2"></i>Recepción Diaria Total MP</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link mb-sm-3 mb-md-1" id="tabs-icons-text-4-tab" data-toggle="tab" href="#tabs-icons-text-4" role="tab" aria-controls="tabs-icons-text-4" aria-selected="false"><i class="fas fa-file mr-2"></i>Recepción Diaria MP A Proceso</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link mb-sm-3 mb-md-1" id="tabs-icons-text-5-tab" data-toggle="tab" href="#tabs-icons-text-5" role="tab" aria-controls="tabs-icons-text-5" aria-selected="false"><i class="fas fa-file mr-2"></i>Recepción Diaria MP A Vertedero u Otro Destino</a>
                    </li>
                </ul>
            </div>
            <div class="card shadow">
                <div class="card-body">
                    <div class="tab-content" id="myTabContent">

                        <!-- REPORTE PROYECTADO VS RECEPCION -->
                        <div class="tab-pane fade show active" id="tabs-icons-text-1" role="tabpanel" aria-labelledby="tabs-icons-text-1-tab">
                            <div class="row">
                                    <div class="col">
                                        REPORTE DE MATERIA PRIMA PROYECTADA VS RECEPCIÓN RESUMEN MES ACTUAL Y ANUAL
                                    </div>
                                </div>
                            <div class="row mt-1">
                                <div class="col">
                                        <div class="tableFixHead" style="width:100%">
                                            <table class="table table-bordered">
                                                <thead class="">
                                                    
                                                    
                                                    <tr>
                                                        <th class="fixed-1 background-salmon-1 text-center"></th>
                                                        <th colspan="7" class="fixed-1 background-salmon-1 text-center border-derecho">Resumen Mensual</th>
                                                        <th colspan="7" class="fixed-1 background-salmon-2 text-center">Resumen Anual</th>
                                                    </tr>

                                                    <tr>
                                                        <th :class="`fixed-2 ${c.class_cabecera} text-center`" v-for="c in columnas_proy_vs_recep" :key="c.label" v-show="c.show">{{c.label}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="clasecita">
                                                    <tr v-for="d in proyectado_vs_recepcion" :key="d.id" v-bind:class="{'background-light':d.seleccionado == 1}">
                                                        <td class="text-center" v-for="c in columnas_proy_vs_recep" :key="c.label" v-show="c.show" @click="d.seleccionado == 1?d.seleccionado= 0:d.seleccionado=1">

                                                            <span v-if="c.tipo == 'string'">{{devuelve_valor(d,c.path,c.tipo)}}</span>
                                                            <span v-if="c.tipo == 'numero_miles'">{{devuelve_valor(d,c.path,c.tipo) |formatear_miles}}</span>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <!-- REPORTE PROYECTADO VS RECEPCION -->


                        <div class="tab-pane fade" id="tabs-icons-text-2" role="tabpanel" aria-labelledby="tabs-icons-text-2-tab">
                            <!-- REPORTE PROYECTADO VS TIPO MATERIA PRIMA -->
                            <div class="tab-pane fade show active" id="tabs-icons-text-1" role="tabpanel" aria-labelledby="tabs-icons-text-1-tab">
                                <div class="row">
                                    <div class="col">
                                        REPORTE DE MATERIA PRIMA PROYECTADA VS RECIBIDA
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col">
                                            <div class="tableFixHead" style="width:100%">
                                                <table class="table table-bordered">
                                                    <thead class="">
                                                        <tr>
                                                            <th :class="`fixed-1 ${c.class_cabecera} text-center`" v-for="c in columnas_proy_vs_tipo_mp" :key="c.label">{{c.label}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="clasecita">
                                                        <tr v-for="i in proy_vs_tipo_mp" :key="i.id" v-bind:class="{'background-light':i.seleccionado == 1}">
                                                            <td :class="`${c.class}`" v-for="c in columnas_proy_vs_tipo_mp" :key="c.label" v-show="c.show" @click="i.seleccionado == 1?i.seleccionado= 0:i.seleccionado=1">

                                                                <span v-if="c.tipo == 'string'">{{devuelve_valor(i,c.path,c.tipo,c.index,c.index_path)}}</span>
                                                                <span v-if="c.tipo == 'numero_miles'">{{devuelve_valor(i,c.path,c.tipo,c.index,c.index_path) | formatear_miles}}</span>
                                                                

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <!-- REPORTE PROYECTADO VS TIPO MATERIA PRIMA -->
                        </div>

                        <div class="tab-pane fade" id="tabs-icons-text-3" role="tabpanel" aria-labelledby="tabs-icons-text-3-tab">
                            <!-- REPORTE DIARIO TOTAL POR TIPO MATERIA PRIMA -->
                            <div class="tab-pane fade show active" id="tabs-icons-text-1" role="tabpanel" aria-labelledby="tabs-icons-text-1-tab">
                                <div class="row">
                                    <div class="col">
                                        RECEPCIÓN TOTAL DIARIA POR MATERIA PRIMA (KG)
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col">
                                            <div class="tableFixHead" style="width:100%">
                                                <table class="table table-bordered">
                                                    <thead class="">
                                                        <tr>
                                                            <th :class="`fixed-1 ${c.class_cabecera} text-center`" v-for="c in columnas_diaria_total_tipo_mp" :key="c.label">{{c.label}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="clasecita">
                                                        <tr v-for="i in total_diario_mp" :key="i.id" v-bind:class="{'background-light':i.seleccionado == 1}">
                                                            <td :class="`${c.class}`" v-for="c in columnas_diaria_total_tipo_mp" :key="c.label" v-show="c.show" @click="i.seleccionado == 1?i.seleccionado= 0:i.seleccionado=1">

                                                                <span v-if="c.tipo == 'string' || c.tipo=='date'">{{devuelve_valor(i,c.path,c.tipo,c.index,c.index_path)}}</span>
                                                                <span v-if="c.tipo == 'numero_miles'">{{devuelve_valor(i,c.path,c.tipo,c.index,c.index_path) | formatear_miles}}</span>

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <!-- REPORTE DIARIO TOTAL POR TIPO MATERIA PRIMA -->
                        </div>

                        <div class="tab-pane fade" id="tabs-icons-text-4" role="tabpanel" aria-labelledby="tabs-icons-text-4-tab">
                            <!-- REPORTE DIARIO A PROCESO POR TIPO MATERIA PRIMA -->
                            <div class="tab-pane fade show active" id="tabs-icons-text-4" role="tabpanel" aria-labelledby="tabs-icons-text-4-tab">
                                <div class="row">
                                    <div class="col">
                                        RECEPCIÓN TOTAL DIARIA A PROCESO (KG)
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col">
                                            <div class="tableFixHead" style="width:100%">
                                                <table class="table table-bordered">
                                                    <thead class="">
                                                        <tr>
                                                            <th :class="`fixed-1 ${c.class_cabecera} text-center`" v-for="c in columnas_diaria_total_tipo_mp_a_proceso" :key="c.label">{{c.label}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="clasecita">
                                                        <tr v-for="i in recep_diaria_a_proceso" :key="i.id" v-bind:class="{'background-light':i.seleccionado == 1}">
                                                            <td :class="`${c.class}`" v-for="c in columnas_diaria_total_tipo_mp_a_proceso" :key="c.label" v-show="c.show" @click="i.seleccionado == 1?i.seleccionado= 0:i.seleccionado=1">

                                                                <span v-if="c.tipo == 'string' || c.tipo=='date'">{{devuelve_valor(i,c.path,c.tipo,c.index,c.index_path)}}</span>
                                                                <span v-if="c.tipo == 'numero_miles'">{{devuelve_valor(i,c.path,c.tipo,c.index,c.index_path) | formatear_miles}}</span>

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <!-- REPORTE DIARIO A PROCESO POR TIPO MATERIA PRIMA -->
                        </div>

                        <div class="tab-pane fade" id="tabs-icons-text-5" role="tabpanel" aria-labelledby="tabs-icons-text-5-tab">
                            <!-- REPORTE DIARIO A VERTEDERO U OTRO DESTINO POR TIPO MATERIA PRIMA -->
                            <div class="tab-pane fade show active" id="tabs-icons-text-5" role="tabpanel" aria-labelledby="tabs-icons-text-5-tab">
                                <div class="row">
                                    <div class="col">
                                        RECEPCIÓN TOTAL DIARIA A VERTEDERO U OTRO DESTINO (KG)
                                    </div>
                                </div>
                                <div class="row mt-1">
                                    <div class="col">
                                            <div class="tableFixHead" style="width:100%">
                                                <table class="table table-bordered">
                                                    <thead class="">
                                                        <tr>
                                                            <th :class="`fixed-1 ${c.class_cabecera} text-center`" v-for="c in columnas_diaria_total_tipo_mp_a_vertedero" :key="c.label">{{c.label}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="clasecita">
                                                        <tr v-for="i in recep_diaria_a_vertedero" :key="i.id" v-bind:class="{'background-light':i.seleccionado == 1}">
                                                            <td :class="`${c.class}`" v-for="c in columnas_diaria_total_tipo_mp_a_vertedero" :key="c.label" v-show="c.show" @click="i.seleccionado == 1?i.seleccionado= 0:i.seleccionado=1">

                                                                <span v-if="c.tipo == 'string' || c.tipo=='date'">{{devuelve_valor(i,c.path,c.tipo,c.index,c.index_path)}}</span>
                                                                <span v-if="c.tipo == 'numero_miles'">{{devuelve_valor(i,c.path,c.tipo,c.index,c.index_path) | formatear_miles}}</span>

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <!-- REPORTE DIARIO A VERTEDERO U OTRO DESTINO POR TIPO MATERIA PRIMA -->
                        </div>

                    </div>
                </div>
            </div>

                <!-- <pre>{{fecha}}</pre>
                <pre>{{total_proy_recep}}</pre> -->
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        fecha:null,
        todos:true,
        columnas_proy_vs_recep:[
            {show:true,label:'Empresa',tipo:'string',path:'empresa',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Proyección del Mes (Ton)',tipo:'numero_miles',path:'proyeccion_mes',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Proyeccion a la Fecha (Ton)',tipo:'numero_miles',path:'proyeccion_dia_actual_mes',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Recibido (Ton)',tipo:'numero_miles',path:'total_recibido_mes',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Recibido C/R (Ton)',tipo:'numero_miles',path:'total_recibido_mes_con_rest',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Recibido S/R (Ton)',tipo:'numero_miles',path:'total_recibido_mes_sin_rest',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Desviación (Ton)',tipo:'string',path:'desviacion_mes_tonelada',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Desviación (%)',tipo:'string',path:'desviacion_mes_porcentaje',class:'border-right',class_cabecera:'background-salmon-1'},
            {show:true,label:'Proyección Anual (Ton)',tipo:'numero_miles',path:'proyeccion_anual',class:'',class_cabecera:'background-salmon-2'},
            {show:true,label:'Proyeccion Anual a la Fecha (Ton)',tipo:'numero_miles',path:'proyeccion_anual_hasta_fecha',class:'',class_cabecera:'background-salmon-2'},
            {show:true,label:'Recibido Anual (Ton)',tipo:'numero_miles',path:'total_recibido_anual',class:'',class_cabecera:'background-salmon-2'},
            {show:true,label:'Recibido C/R Anual (Ton)',tipo:'numero_miles',path:'total_recibido_anual_con_rest',class:'',class_cabecera:'background-salmon-2'},
            {show:true,label:'Recibido S/R Anual (Ton)',tipo:'numero_miles',path:'total_recibido_anual_sin_rest',class:'',class_cabecera:'background-salmon-2'},
            {show:true,label:'Desviación Anual (Ton)',tipo:'string',path:'desviacion_anual_tonelada',class:'',class_cabecera:'background-salmon-2'},
            {show:true,label:'Desviación Anual (%)',tipo:'string',path:'desviacion_anual_porcentaje',class:'',class_cabecera:'background-salmon-2'},
        ],
        columnas_proy_vs_tipo_mp:[
            {show:true,label:'Mes',tipo:'string',path:'mes',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Subproducto Proyectado',tipo:'numero_miles',path:'proyectado',class:'text-center',index:0,index_path:'materias_primas',class_cabecera:'background-salmon-1'},
            {show:true,label:'Subproducto Recibido',tipo:'numero_miles',path:'total_recibido',class:'text-center',index:0,index_path:'materias_primas',class_cabecera:'background-salmon-1'},
            {show:true,label:'Subproducto CR',tipo:'numero_miles',path:'total_con_rest',class:'text-center',index:0,index_path:'materias_primas',class_cabecera:'background-salmon-1'},
            {show:true,label:'Subproducto SR',tipo:'numero_miles',path:'total_sin_rest',class:'text-center',index:0,index_path:'materias_primas',class_cabecera:'background-salmon-1'},
            {show:true,label:'Ensilaje Proyectado',tipo:'numero_miles',path:'proyectado',class:'text-center',index:1,index_path:'materias_primas',class_cabecera:'background-salmon-1'},
            {show:true,label:'Ensilaje Recibido',tipo:'numero_miles',path:'total_recibido',class:'text-center',index:1,index_path:'materias_primas',class_cabecera:'background-salmon-1'},
            {show:true,label:'Mortalidad Proyectado',tipo:'numero_miles',path:'proyectado',class:'text-center',index:2,index_path:'materias_primas',class_cabecera:'background-salmon-1'},
            {show:true,label:'Mortalidad Recibido',tipo:'numero_miles',path:'total_recibido',class:'text-center',index:2,index_path:'materias_primas',class_cabecera:'background-salmon-1'},
            {show:true,label:'Pesca Pelágica Proyectado',tipo:'numero_miles',path:'proyectado',class:'text-center',index:3,index_path:'materias_primas',class_cabecera:'background-salmon-1'},
            {show:true,label:'Pesca Pelágica Recibido',tipo:'numero_miles',path:'total_recibido',class:'text-center',index:3,index_path:'materias_primas',class_cabecera:'background-salmon-1'},
            {show:true,label:'Total Proyectado',tipo:'numero_miles',path:'total_proyectado',class:'negrita-1 text-center',class_cabecera:'background-salmon-1'},
            {show:true,label:'Total Recibido',tipo:'numero_miles',path:'total_recibido',class:'negrita-1 text-center',class_cabecera:'background-salmon-1'},
        ],

        columnas_diaria_total_tipo_mp:[
            {show:true,label:'Fecha',tipo:'date',path:'dia',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Subproducto',tipo:'numero_miles',path:'total',class:'text-center',index:0,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Ensilaje',tipo:'numero_miles',path:'total',class:'text-center',index:1,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Mortalidad',tipo:'numero_miles',path:'total',class:'text-center',index:2,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Pesca Pelágica',tipo:'numero_miles',path:'total',class:'text-center',index:3,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Total Recibido',tipo:'numero_miles',path:'total',class:'negrita-1 text-center',class_cabecera:'background-salmon-1'},
        ],

        columnas_diaria_total_tipo_mp_a_proceso:[
            {show:true,label:'Fecha',tipo:'date',path:'dia',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Subproducto',tipo:'numero_miles',path:'total',class:'text-center',index:0,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Subproducto C/R',tipo:'numero_miles',path:'con_restriccion',class:'text-center',index:0,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Subproducto S/R',tipo:'numero_miles',path:'sin_restriccion',class:'text-center',index:0,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Ensilaje',tipo:'numero_miles',path:'total',class:'text-center',index:1,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Mortalidad',tipo:'numero_miles',path:'total',class:'text-center',index:2,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Pesca Pelágica',tipo:'numero_miles',path:'total',class:'text-center',index:3,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Total Recibido',tipo:'numero_miles',path:'total',class:'negrita-1 text-center',class_cabecera:'background-salmon-1'},
        ],

        columnas_diaria_total_tipo_mp_a_vertedero:[
            {show:true,label:'Fecha',tipo:'date',path:'dia',class:'',class_cabecera:'background-salmon-1'},
            {show:true,label:'Subproducto',tipo:'numero_miles',path:'total',class:'text-center',index:0,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Ensilaje',tipo:'numero_miles',path:'total',class:'text-center',index:1,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Mortalidad',tipo:'numero_miles',path:'total',class:'text-center',index:2,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Pesca Pelágica',tipo:'numero_miles',path:'total',class:'text-center',index:3,index_path:'mps',class_cabecera:'background-salmon-1'},
            {show:true,label:'Total Recibido',tipo:'numero_miles',path:'total',class:'negrita-1 text-center',class_cabecera:'background-salmon-1'},
        ],

        proveedores:[],
        datos:[],
        mps_id:[],
        destinos_id:[],
        empresas_id:[],
        especies_id:[],
        materias_primas:[],
        especies:[],
        mps_seleccionadas:[],
        destinos:[],
        total_resultado:null,
        agrupar_empresa:true,
        agrupar_sucursal:true,

        proyectado_vs_recepcion:[],
        proy_vs_tipo_mp:[],
        total_diario_mp:[],
        recep_diaria_a_proceso:[],
        recep_diaria_a_vertedero:[],
        url_excel:null,

    }),
    mounted(){
        this.fecha = new Date();
        this.cargar_materias_primas();
    },
    methods:{
        async cargar_materias_primas(){
          await this.axios.get(`${this.api}/mps_tipo?limit=999999999`,this.cabeceras_json,).then(res=>{
                this.materias_primas = res.data.data.data;
            }).catch(e=>{
                //console.log(e);
            });
            this.cargar_destinos();
        },

        async cargar_destinos(){
          await this.axios.get(`${this.api}/destinos`,this.cabeceras_json,).then(res=>{
                this.destinos = res.data.data;
            }).catch(e=>{
                //console.log(e);
            });
            this.cargar_proveedores();
        },

        async cargar_proveedores(){
            await this.axios.get(`${this.api}/empresas?tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,this.cabeceras_json).then((res)=>{
            this.proveedores = res.data.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          });
          this.cargar_especies();
        },

        async cargar_especies(){
            await this.axios.get(`${this.api}/especies?limit=9999999999`,this.cabeceras_json).then((res)=>{
            this.especies = res.data.data.data;
          }).catch((e)=>{
            //console.log(e);
          });
        },

        async filtrarProveedores(search){
          await this.axios.get(`${this.api}/empresas?nombre=${search}&tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,this.cabeceras_json).then((res)=>{
            this.proveedores = res.data.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          });
          ////console.log('search',search)
          ////console.log('col',col)
        },

        async cargar_datos(){
            if(this.fecha != null && this.fecha != undefined){
                let meses = [];
                let dateStart = this.$moment(this.fecha).startOf('year')
                let dateEnd = this.$moment(this.fecha);
                while (dateEnd.diff(dateStart, 'months') > 0) {
                    meses.push(dateStart.format('MMMM'));
                    dateStart.add(1, 'month');
                }
                let body = {
                    desde:this.$moment(this.fecha).startOf('month').format('YYYY-MM-DD'),
                    hasta:this.fecha,
                    primer_dia_anio:this.$moment(this.fecha).startOf('year').format('YYYY-MM-DD'),
                    anio:this.$moment(this.fecha).format('YYYY'),
                    mes:this.$moment(this.fecha).format('MMMM'),
                    mes_actual_con_dias:this.mes_actual_con_dias,
                    meses:meses,
                    meses_con_fechas:this.meses_fecha,
                    total_dias_mes:this.$moment(this.fecha).endOf('month').format('DD'),
                    dia:this.$moment(this.fecha).format('DD'),
                    mps_id:this.mps_id,
                    empresas_id:this.empresas_id,
                    destinos_id:this.destinos_id,
                    especies_id:this.especies_id,
                    agrupar_empresa:this.agrupar_empresa,
                    agrupar_sucursal:this.agrupar_sucursal,
                    columnas:this.columnas_proy_vs_recep.filter(c => c.show == true).map((c)=>{
                        return {cabecera:c.label,path:c.path}
                    })
                };
                await this.axios.post(`${this.api}/reportes/consolidado`,body,this.cabeceras_json).then(res=>{
                    //console.log(res.data.data);
                    this.proyectado_vs_recepcion = res.data.data.proyectado_Subproducto_vs_recepcion_Subproducto;
                    this.total_proy_recep = res.data.data.total_proy_recep;
                    this.proy_vs_tipo_mp = res.data.data.proy_vs_tipo_mp;
                    this.total_diario_mp = res.data.data.recep_diaria_total_mp;
                    this.recep_diaria_a_proceso = res.data.data.recep_diaria_total_mp_a_proceso;
                    this.recep_diaria_a_vertedero = res.data.data.recep_diaria_total_mp_a_vertedero;
                    this.url_excel = res.data.data.url;
                    //this.url_excel = res.data.data.url_excel;
                }).catch(e=>{
                    //console.log(e);
                });
            }
            
        },

        async exportar_excel(){
            window.open(this.url_excel, '_blank');
            /* let body = {
                desde:this.fechas[0],
                hasta:this.fechas[1],
                mps_id:this.mps_id,
                empresas_id:this.empresas_id,
                destinos_id:this.destinos_id,
                especies_id:this.especies_id,
                agrupar_empresa:this.agrupar_empresa,
                agrupar_sucursal:this.agrupar_sucursal,
                columnas:this.columnas.filter(c => c.show == true && c.path != 'declaracion_jurada' && c.path != 'cam').map((c)=>{
                    return {cabecera:c.label,path:c.path}
                })
            };
            await this.axios.post(`${this.api}/reportes/personalizado_excel`,body,this.cabeceras_json).then((res)=>{
                this.url_excel = res.data.data.url;
                
                //console.log(this.url_excel,res.data);
            }).catch((e)=>{
                //console.log(e);
            }); */
        },

        devuelve_valor(item,path,tipo_dato,index=null,index_path=null){
          let keys = path.split('.');
          let valor = item;
          if(index != null){
              valor = item[index_path][index];
          }
          
          keys.forEach(k => {
                for (var key in valor) {
                  if(key == k){
                    valor = valor[key];
                  }
                }
                  
          });
          if(tipo_dato == 'datetime'){
            valor = this.$options.filters.fecha_hora(valor);
          }
          if(tipo_dato == 'date'){
            valor = this.$options.filters.fecha(valor);
          }
          if(tipo_dato == 'time'){
            valor = this.$options.filters.hora(valor);
          }
          return valor;
        },

        setearTodos(){
            this.columnas.forEach(c => {
                c.show = this.todos;
            });
        },

        abrirPdf(d){
            window.open(`${this.api_public}/guias/${d.url_guia}`, '_blank');
        },

        abrirDeclaracion(d){
            window.open(`${this.api_public}/guias/archivos_adicionales/${d.declaracion_jurada}`, '_blank');
        },

        abrirCam(d){
            window.open(`${this.api_public}/guias/archivos_adicionales/${d.cam}`, '_blank');
        },

        
    },
    computed:{

        meses_fecha(){
            let array = [];
            let dateStart = this.$moment(this.fecha).startOf('year')
            let dateEnd = this.$moment(this.fecha).endOf('year');
            for(let i = 0; i < 12; i++){
                array.push({
                    mes:dateStart.format('MMMM'),
                    inicio:this.$moment(dateStart).startOf('month').format('YYYY-MM-DD'),
                    fin:this.$moment(dateStart).endOf('month').format('YYYY-MM-DD')
                })
                //array.push(dateStart.format('MMMM'));
                dateStart.add(1, 'month');
            }
            /* while (dateEnd.diff(dateStart, 'months') == 0) {
                array.push({
                    mes:dateStart.format('MMMM'),
                    inicio:this.$moment(dateStart).startOf('month').format('YYYY-MM-DD'),
                    fin:this.$moment(dateStart).endOf('month').format('YYYY-MM-DD')
                })
                //array.push(dateStart.format('MMMM'));
                dateStart.add(1, 'month');
            } */
            return array;
        },

        mes_actual_con_dias(){
            let array = [];
            let dateStart = this.$moment(this.fecha).startOf('month')
            let dateEnd = this.$moment(this.fecha);
            while (dateEnd.diff(dateStart, 'days') >= 0) {
                array.push({
                    dia:dateStart.format('YYYY-MM-DD')
                })
                //array.push(dateStart.format('MMMM'));
                dateStart.add(1, 'day');
            }
            return array;
        },
        ...mapState(['api','api_public','cabeceras_json','token'])
    }
}
</script>
<style>
.tableFixHead          { overflow: auto; height: 600px; }
/*.tableFixHead thead th { position: sticky; top: 0; z-index: 100; }*/

.fixed-1{
    position: sticky; top: 0px; z-index: 1; height:40.6px;
}
.fixed-2{
    position: sticky; top: 40.6px; z-index: 1; height:40.6px;
}

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
/*th     { background:#427391; color:#fff }*/
.margen-1{
    margin: 0em 0.5em;
}

.border-derecho{
    border-right: 1px solid #fff !important;
    z-index: 101;
}
.border-left{
    border-right: 1px solid #fff;
}

.negrita-1{
    font-size: 18px;
    font-weight: bold;
}

.clasecita tr:last-child{
    font-size: 18px;
    font-weight: bold;
}


.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #3c3c3c;
    background-color: #fec89a;
}

.nav-pills .nav-link {
    font-size: .875rem;
    font-weight: 500;
    padding: .75rem 1rem;
    transition: all .15s ease;
    color: #3c3c3c;
    background-color: #fff;
    box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08);
}

.nav-pills .nav-link:hover {
    color: #3c3c3c;
    background-color: #fec89a;
}

</style>